import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Article, ArticleUnit } from '../article/article';
import { ArticleService } from '../article/article.service';

import { SelectItem, Message } from 'primeng/primeng'

@Component({
  selector: 'app-article-detail',
  templateUrl: './article-detail.component.html',
  styleUrls: ['./article-detail.component.css']
})
export class ArticleDetailComponent implements OnInit {

  public article: Article;
  private unitTypes: SelectItem[];
  public selectedUnit: ArticleUnit;
  public msgs: Message[] = [];
  private isEdit: boolean;

  constructor(private route: ActivatedRoute, private router: Router,
    private articleService: ArticleService) {
    this.article = new Article();

    /**
     * Initialize unit types
     */
    this.unitTypes = [];
    this.unitTypes.push({ label: 'Lager', value: 'W' });
    this.unitTypes.push({ label: 'Lieferung', value: 'R' });
    this.unitTypes.push({ label: 'Verkauf', value: 'S' });
    this.unitTypes.push({ label: 'Palette', value: 'P' });

    this.addUnit();

    this.isEdit = false;
  }

  public getBaseUnitOptions(): SelectItem[] {
    let units: SelectItem[] = [];
    for (var unit of this.article.units) {
      let item: SelectItem = { label: unit.unit, value: unit.id };
      units.push(item);
    }
    return units;
  }

  /**
   * Determines lowest free id within list of units 
   * and adds new unit with lowest free id.
   */
  public addUnit() {
    let id: number = 0;
    for (var unit of this.article.units) {
      if (id <= unit.id)
        id = unit.id + 1;
    }
    let newUnit: ArticleUnit = new ArticleUnit();
    newUnit.id = id;
    newUnit.type = 'W';
    newUnit.baseFactor = 1.0;

    this.article.units = [...this.article.units, newUnit];
    console.log('New unit was pushed to unit array.');
  }

  ngOnInit() {
    // Here we go, we need to check if there was an id passed. if so, we 
    // have to query article details to enable edit of article.
    if(this.route.snapshot.params['id'] != null)
    {
      this.articleService.qryArticle(+this.route.snapshot.params['id']).subscribe(
        (article : Article) => {
          if(article != null)
          {
          this.article = article;
          this.isEdit = true;
          }else{
            this.msgs.push({severity: 'warn', summary:'Failed to load article.'});
          }
        },
        (err) => {
          this.msgs = [];
          this.msgs.push({severity:'warn',summary: 'Failed to load article.'})
        }
      );
    }
    
  }

  /**
   * Deletes previously selected units from list of units of this article.
   */
  public deleteSelectedUnit() {
    console.log('deleteSelectedUnit was triggered.');
    if (this.selectedUnit == null) {
      this.msgs = [];
      let msg: Message = { severity: 'info', summary: 'Keine Auswahl.', detail: 'Es wurde keine Unit ausgewaehlt.' };
      this.msgs.push(msg);
      return;
    }
    let units: ArticleUnit[] = [];
    for (var i = 0; i < this.article.units.length; i++) {
      if (this.article.units[i].id != this.selectedUnit.id) {
        units.push(this.article.units[i]);
      } else {
        if (this.article.baseUnitId = this.article.units[i].id)
          this.article.baseUnitId = null;
      }
    }
    this.article.units = units;
    this.selectedUnit = null;
  }

  /**
   * Saves article.
   */
  public onSubmit() {
    if (!this.isEdit) {
      this.articleService.save(this.article).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Artikel wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.router.navigateByUrl('/article');
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Artikel konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save article, error msg: ' + err);
        }
      );
    }else{
      this.articleService.update(this.article).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Artikel wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.router.navigateByUrl('/article');
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Artikel konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save article, error msg: ' + err);
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/article-detail/article-detail.component.ts